(function () {
  const scrollToTarget = (targetId) => {
    const target = document.getElementById(targetId);
    if (!target) return;
    target.scrollIntoView({ behavior: 'smooth', block: 'start' });
    window.setTimeout(() => {
      const firstInput = target.querySelector('input, textarea');
      if (firstInput) firstInput.focus({ preventScroll: true });
    }, 450);
  };

  document.querySelectorAll('[data-sinead-scroll-to-form]').forEach((trigger) => {
    trigger.addEventListener('click', (event) => {
      event.preventDefault();
      const targetId =
        trigger.dataset.scrollTarget ||
        trigger.getAttribute('href')?.replace(/^#/, '') ||
        'contact-form';
      scrollToTarget(targetId);
    });
  });

  const popup = document.querySelector('[data-sinead-consult-popup]');
  if (!popup) return;

  const storageKey = popup.dataset.storageKey || 'sinead-contact-consult-popup-dismissed';
  const autoShow = popup.dataset.autoShow === 'true';
  const delay = parseInt(popup.dataset.delay || '600', 10);
  const formTargetId = popup.dataset.formTarget || 'contact-form';
  const primaryLink = popup.dataset.primaryLink || '';

  const open = () => {
    popup.hidden = false;
    popup.classList.add('is-open');
    document.body.classList.add('sinead-consult-popup-open');
    const dialog = popup.querySelector('.sinead-consult-popup__dialog');
    if (dialog) dialog.focus();
  };

  const close = () => {
    popup.classList.remove('is-open');
    popup.hidden = true;
    document.body.classList.remove('sinead-consult-popup-open');
    try {
      sessionStorage.setItem(storageKey, '1');
    } catch (e) {
      /* ignore */
    }
  };

  popup.querySelectorAll('[data-sinead-consult-popup-close]').forEach((el) => {
    el.addEventListener('click', close);
  });

  const primary = popup.querySelector('[data-sinead-consult-popup-primary]');
  if (primary) {
    primary.addEventListener('click', () => {
      close();
      const onPageForm = formTargetId && document.getElementById(formTargetId);
      if (onPageForm) {
        scrollToTarget(formTargetId);
      } else if (primaryLink) {
        window.location.assign(primaryLink);
      }
    });
  }

  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape' && popup.classList.contains('is-open')) {
      close();
    }
  });

  document.querySelectorAll('[data-sinead-consult-popup-open]').forEach((trigger) => {
    trigger.addEventListener('click', (event) => {
      event.preventDefault();
      open();
    });
  });

  if (autoShow) {
    try {
      if (!sessionStorage.getItem(storageKey)) {
        window.setTimeout(open, delay);
      }
    } catch (e) {
      window.setTimeout(open, delay);
    }
  }
})();
